export default __webpack_public_path__ + "static/media/jules.af153a56.jpg";